module.exports = __webpack_public_path__ + "media/images/icons/academy-addon-415c02d423760ab4237c5b25cf60a09a.svg";